import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { IReport } from '../../models/Interfaces/IReport';
import { IReportRow } from '../../models/Interfaces/IReportRow';
import { MathExt } from '../../classes/MathExt';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-report-data-show-table',
  templateUrl: './report-data-show-table.component.html',
  styleUrls: ['./report-data-show-table.component.css'],
})
export class ReportDataShowTableComponent implements OnInit {
  @Input() report: IReport;
  @Input() index: number;
  untouched: boolean = true;
  edit: boolean = false;
  cellResetBehavior: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  constructor() {}

  ngOnInit(): void {}

  public CreateReportTableId(date: Date, index: number): string {
    const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date);
    const mo = new Intl.DateTimeFormat('en', { month: 'short' }).format(date);
    const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date);
    const dateString: string = `${ye}-${mo}`;
    return `${dateString}-report-table-${index}`;
  }

  setMarketingCost(newCost: number, row: IReportRow): void {
    this.untouched = false;
    row.marketing_cost = newCost;
    this.calculateFinancialBalance(row);
  }

  private calculateFinancialBalance(row: IReportRow): void {
    row.financial_balance = row.revenue_sum - row.marketing_cost;
  }

  resetMarketingCost(row: IReportRow): void {
    row.marketing_cost = 0;
    row.financial_balance = 0;
  }

  resultDependCellColoring(num: number): string {
    if (num === 0) return 'table-info';

    if (MathExt.IsNegative(num)) return 'table-danger';

    return 'table-success';
  }

  setReset(): void {
    this.cellResetBehavior.next(true);
    this.untouched = true;
    for (let row of this.report.rows) {
      row.financial_balance = 0;
      row.marketing_cost = 0;
    }
  }

  printTable(tableId: string): void {
    let table = document.getElementById(tableId) as HTMLTableElement;
    var html = '<!DOCTYPE HTML>';
    html += '<html lang="en-us">';
    html += `<head>
      <title>Riport nyomtatási nézet ${tableId}</title>
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.6.0/dist/css/bootstrap.min.css" integrity="sha384-B0vP5xmATw1+K9KRQjQERJvTumQW0nPEzvF6L/Z6nronJ3oUOFUFpCjEUQouq2+l" crossorigin="anonymous">
      <style>
        .print-hidden {
          display: none;
        }
      </style>
      </head>`;
    html += '<body>';
    html += table.outerHTML;
    html += ``;
    html += '</body>';
    let win = window.open();
    win.document.write(html);
    win.document.close();
  }

  convToString(number: Number): string {
    return number.toString();
  }
}
